export default process.env.NODE_ENV === 'production' ? 'https://reabilitaretermica.eu' : 'http://localhost:10200'
